import React, { FC } from 'react'
import { breakpoint, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Text, Flex } from '@moonpig/launchpad-components'
import {
  IconSystemCornerDownRight,
  IconSystemSearch,
} from '@moonpig/launchpad-assets'
import { SearchFallbackRow } from '../types'
import { useLocaleText } from '../../locale'

const ICON_SIZE_PX = '20px'

const StyledText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
`

const StyledButtonText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;

  ${s({
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '20px',
    color: 'colorInteractionControl',
  })}
`

const StyledSearchIconWrapper = styled(Flex)`
  ${s({
    bgcolor: 'colorBackground01',
    borderRadius: 1,
    p: 4,
    color: 'colorInteractionControl',
  })}
`

const StyledCornerDownIconWrapper = styled(Flex)`
  ${s({
    bgcolor: 'colorBackground01',
    color: 'colorInteractionControl',
  })}
`

const StyleContainer = styled(Flex)`
  ${s({
    width: '100%',
    maxWidth: '90%',
    overflow: 'hidden',
    gap: '8px;',
  })}
`

const EnterButton = styled.div`
  display: none;

  ${breakpoint('md')} {
    display: flex;
    align-items: center;
    justify-content: center;

    ${s({
      borderColor: 'colorBorder03',
      bgcolor: 'colorPrimary03',
      borderRadius: 1,
      padding: 4,
      border: 1,
      gap: 4,
      width: '86px',
    })}
  }
`

export const SearchFallback: FC<{ row: SearchFallbackRow }> = ({ row }) => {
  const t = useLocaleText()
  const item = row.item as {
    value: string
    department?: { name: string; title: string }
  }
  const text =
    item.department && item.department.name !== 'all'
      ? t('search.search_term_in_department', {
          searchTerm: item.value,
          departmentTitle: item.department.title.toLowerCase(),
        })
      : t('search.search_for_with_term', {
          searchTerm: item.value,
        })

  const enterButtonText = t('search.enter').toLocaleUpperCase()

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <StyleContainer>
        <StyledSearchIconWrapper>
          <IconSystemSearch width={ICON_SIZE_PX} height={ICON_SIZE_PX} />
        </StyledSearchIconWrapper>
        <StyledText typography="typeBodyText" color="colorTextLabel">
          {text}
        </StyledText>
      </StyleContainer>

      <EnterButton>
        <StyledCornerDownIconWrapper>
          <IconSystemCornerDownRight
            width={ICON_SIZE_PX}
            height={ICON_SIZE_PX}
          />
        </StyledCornerDownIconWrapper>
        <StyledButtonText typography="typeButtonLabel">
          {enterButtonText}
        </StyledButtonText>
      </EnterButton>
    </Flex>
  )
}
